module.exports = __webpack_public_path__ + "img/user-solid.ffcf7ed3.svg";